import { Scaffold } from 'layouts';
import { LoadingOrders } from 'components/Pages/ScheduledReports';

export const LoadingOrdersPage = () => (
  <Scaffold>
    <LoadingOrders />
  </Scaffold>
);
